<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t6">Les lieux rencontrés</span></p>
<p class="p5"><span class="t6"> </span></p>
<p class="p6"><span class="t5">Par ordre de parution dans le texte</span></p>
<p class="p5"> </p>
<p class="p7">Plymouth : ville située au sud-ouest de l’Angleterre, à 350 km de Londres, à l’embouchure de deux fleuves qui se rejoignent pour former un port naturel.</p>
<p class="p7">Spithead : bras de mer qui sépare l’île de Wight du reste de l’Angleterre, à proximité de Portsmouth. Protégée des vents, cette zone est souvent utilisée pour ancrer des navires de la Royal Navy.</p>
<p class="p7">Lizard Point : En Cornouailles, point le plus au sud d’Angleterre.</p>
<p class="p7">Torbay : Baie située entre Exeter et Plymouth, dans le sud-ouest de l’Angleterre</p>
<p class="p5"><span class="t6"> </span></p>
<p class="p0"><span class="t6">Les officiers de la Royal Navy</span></p>
<p class="p7"> </p>
<p class="p7">Amiral de la flotte <span class="t5">– le plus haut grade –</span> amiral, vice-amiral, contre-amiral et commodore : officiers généraux.</p>
<p class="p7">Capitaine, commandant, lieutenant-commandant : officiers supérieurs, selon l’importance du bâtiment qu’ils commandent.</p>
<p class="p7">Lieutenant, sous-lieutenant : officiers susceptibles de recevoir le commandement d’un petit navire en cas de besoin, mais ils ne sont pas inscrit sur les listes d’active, aussi doivent-ils encore prouver leur valeur pour espérer un poste ferme.</p>
<p class="p7">Aspirant : grade d’officier le plus bas, attribué d’office aux jeunes bien-nés qui embarquaient pour la première fois, mais aussi le commencement obligatoire de toute carrière navale.</p>
<p class="p5"><span class="t6"> </span></p>
<p class="p0"><span class="t6">Les navires</span></p>
<p class="p7"> </p>
<p class="p7">Brick : deux mâts taillé pour la course en mer et le convoyage.</p>
<p class="p7">Corvette : petit navire de guerre, léger et rapide, qui apparaît en France à la fin du XVIIe siècle.</p>
<p class="p7">Frégate : bâtiment de guerre, rapide et manœuvrier, plus grand et mieux armé qu’une corvette.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?6816f588